export default __webpack_public_path__ + "static/media/draw.2f57f6cd.svg";